onReady(($) => {
    if (!document.querySelector('.module_collection_menu')) {
        return
    }

    const moduleCollectionMenu = $('.module_collection_menu');

    const navContainer = $('.navigationcontainer');
    const $window = $(window);

    $('#main-button, #close-button, .menu a')
        .on('click', () => moduleCollectionMenu.toggleClass('open'))

    $window.on('scroll', () => {
        if ($window.scrollTop()) {
            moduleCollectionMenu.addClass('slide-up')
            navContainer.addClass('slide-up')
            return
        }

        moduleCollectionMenu.removeClass('slide-up')
        navContainer.removeClass('slide-up')
    });
});
